import styled from '@emotion/styled';
import { Box } from '../../../../../Box';
import {
  stylesForDefaultState,
  stylesForFocusState,
  stylesForHoverState,
} from '../../../../../_internal/theme/stylesFor';

const WindowedOptionsContainer = styled(Box)`
  overflow: hidden;
  ${stylesForDefaultState('select')}

  &:hover {
    cursor: pointer;
    ${stylesForHoverState('select')}
  }

  &:focus {
    ${stylesForFocusState('select')}
  }
`;

export default WindowedOptionsContainer;
